export default __webpack_public_path__ + "static/media/external-link.90145f03.svg";